// 线上环境
export const urlPre = '//myapp.com';
export const urlPath = '//img1.sj.qq.com/res/static/myapp';
// 静态文件版本
export const staticVersion = '20140928';

// 根据当前访问地址判断是否读取静态源文件/打包静态源文件||定义seajs静态文件主域
export const sourceMap = () => {
  if (urlPre.includes('sj.qq.com') || urlPre.includes('myapp.com') || urlPre.includes('androidpc')) {
    return {
      datePath: '/staticVersion/' + staticVersion,
      assets: '/assets',
      source: '',
      staticDomain: urlPath + '/staticVersion/' + staticVersion
    };
  } else {
    return {
      datePath: '',
      assets: '',
      source: '/src',
      staticDomain: urlPath
    };
  }
};

// 根据当前访问地址判断是否读取线上文件
export const onlineMap = () => {
  let imgRand;
  if (urlPre.includes('myapp.com')) {
    imgRand = ['//img1.sj.qq.com/res/static/myapp', '//img2.sj.qq.com/res/static/myapp', '//img3.sj.qq.com/res/static/myapp', '//img4.sj.qq.com/res/static/myapp', '//img5.sj.qq.com/res/static/myapp', '//img6.sj.qq.com/res/static/myapp'];
  } else {
    imgRand = [urlPath, urlPath, urlPath, urlPath, urlPath, urlPath];
  }
  return imgRand;
};

export const pageTitle = '应用宝市场';
export const pageStyleHref = '';

// 时间戳
export const timestamp = '20140928';

// 加载外部css文件
export const dynamicLoadCss = (pageStyleHref) => {
  const { datePath, assets, source } = sourceMap();
  const imgRand = onlineMap();
  const css = document.createElement('link');
  css.href = `${imgRand[5]}${datePath}${assets}/css${source}/app/page/${pageStyleHref}Less-v1.css?t=${timestamp}.css;`;
  css.rel = 'stylesheet';
  css.type = 'text/css';
  document.head.appendChild(css);
};

export const seajs = () => {
  const imgRand = onlineMap();
  const { assets, source } = sourceMap();
  return `${imgRand[3]}${assets}/js${source}/lib/seajs/2.0/sea.js`;
};

export const baseUrl = 'https://sj.qq.com';
